export default "__VITE_ASSET___at2zqmg__"